module.exports = __webpack_public_path__ + "static/assets/3acc4cfc908cd5d8d5caa04028902aec.png";